import { useEffect, useRef } from "react";
import { useToast } from "./toast/ToastProvider";

type SuccessNoticeProps = {
  title: string;
  description?: string;
  onClose?: () => void;
  closeLabel?: string;
};

export function SuccessNotice({ title, description }: SuccessNoticeProps) {
  const toast = useToast();
  const lastKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const key = `success:${title}:${description ?? ""}`;
    if (lastKeyRef.current === key) {
      return;
    }
    lastKeyRef.current = key;
    toast.success(title, description);
  }, [description, title, toast]);

  return null;
}
